import { render, staticRenderFns } from "./Layout_GLYF_expert.vue?vue&type=template&id=47e6094e&scoped=true"
import script from "./Layout_GLYF_expert.vue?vue&type=script&lang=js"
export * from "./Layout_GLYF_expert.vue?vue&type=script&lang=js"
import style0 from "./Layout_GLYF_expert.vue?vue&type=style&index=0&id=47e6094e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e6094e",
  null
  
)

export default component.exports